import React from 'react'
import { useNavigate } from 'react-router-dom'
import { splitThisOrder } from 'client/utils/api-routes-orders'
import {
  DcButton,
  PixelFactoryContext,
  Section,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { get } from 'utils/api-routes.util'
import { ButtonContainer } from 'app/common/styles/section'

import LineItems from './LineItems'
import { SubDiscount, SplitDiscount } from './SplitDiscount'
import SubOrders from './SubOrders'
import { IPixelFactory, OrderDetail } from '../../../../decl.d'
interface SplitOrderProps {
  sub_order_1_line_items: Array<any>
  sub_order_2_line_items: Array<any>
  sub_order_1_discounts: Array<any>
  sub_order_2_discounts: Array<any>
}

interface IProps {
  setSplitOrder: (data: any) => void
  splitId: number
  SetShowOrderDetailModal: (data: any) => void
  setReload: (data: any) => void
}
const SplitOrder = (props: IProps) => {
  const { setSplitOrder, splitId, SetShowOrderDetailModal, setReload } = props
  const [mainOrder, setMainOrder] = React.useState<OrderDetail>()

  const [splitOrder, setSplitOrderData] = React.useState<SplitOrderProps>({
    sub_order_1_line_items: [],
    sub_order_2_line_items: [],
    sub_order_1_discounts: [],
    sub_order_2_discounts: [],
  })

  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  React.useEffect(() => {
    getOrderDetails(splitId)
  }, [])
  const navigate = useNavigate()
  const getOrderDetails = (detailID) => {
    showPageLoader()
    get(`/orders/${detailID}`).subscribe((res: AjaxResponse<any>) => {
      setMainOrder({
        ...res?.response?.data,
        line_items: res?.response?.data?.line_items.map((item) => {
          return {
            ...item,
            totalQuantity: item.quantity,
          }
        }),
      })
      const sub_order_1_line_items = res?.response?.data?.line_items
      const sub_order_2_line_items = res?.response?.data?.line_items.map(
        (item) => {
          return {
            ...item,
            quantity: 0,
          }
        },
      )
      const sub_order_1_discounts = res?.response?.data?.discount_lines.map(
        (item) => {
          return {
            ...item,
            amount: item.amount,
          }
        },
      )
      const sub_order_2_discounts = res?.response?.data?.discount_lines.map(
        (item) => {
          return {
            ...item,
            amount: 0,
          }
        },
      )
      setSplitOrderData({
        ...splitOrder,
        sub_order_1_line_items,
        sub_order_2_line_items,
        sub_order_1_discounts,
        sub_order_2_discounts,
      })

      hidePageLoader()
    })
  }

  const SplitOrder = () => {
    const sub_order_1_line_items = splitOrder?.sub_order_1_line_items?.filter(
      (item) => item.quantity > 0,
    )
    const sub_order_2_line_items = splitOrder?.sub_order_2_line_items?.filter(
      (item) => item.quantity > 0,
    )
    if (
      sub_order_1_line_items?.length === 0 ||
      sub_order_2_line_items?.length === 0
    ) {
      showFailure('Both split orders must have atleast one line item')
      return
    }
    showPageLoader()
    splitThisOrder(splitId, splitOrder).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res?.response?.data) {
        showSuccess('Order split successfully')
        setSplitOrder({ isSplit: false, splitId: null })
        setReload(true)
        SetShowOrderDetailModal(false)
        navigate('/orders')
      } else {
        showFailure(res?.response?.error)
      }
    })
  }

  const maxQuantity = (id) => {
    const quantity = mainOrder?.line_items.find(
      (item) => item.variation_id == id,
    ).quantity
    return quantity
  }
  const updateSelectedLineItems = (variation_id, value, split_order) => {
    const maxQty = maxQuantity(variation_id)
    if (value > maxQty) {
      showFailure(`Max quantity is ${maxQty} for this product`)
    } else {
      if (split_order === 1) {
        splitOrder?.sub_order_1_line_items?.map((item) => {
          if (item.variation_id === variation_id) {
            item.quantity = value
            item.total = value * item.price
          }
        })

        splitOrder?.sub_order_2_line_items?.map((item) => {
          if (item.variation_id === variation_id) {
            item.quantity = maxQty - value
            item.total = (maxQty - value) * item.price
          }
        })
      } else {
        splitOrder?.sub_order_2_line_items?.map((item) => {
          if (item.variation_id === variation_id) {
            item.quantity = value
            item.total = value * item.price
          }
        })
        splitOrder?.sub_order_1_line_items?.map((item) => {
          if (item.variation_id === variation_id) {
            item.quantity = maxQty - value
            item.total = (maxQty - value) * item.price
          }
        })
      }
      setSplitOrderData({ ...splitOrder })
    }
  }
  const maxDiscount = (id) => {
    const discount = mainOrder?.discount_lines.find(
      (item) => item.order_discount_line_id == id,
    ).amount
    return discount
  }
  const updateDiscount = (value, id, subOrder) => {
    if (value > maxDiscount(id)) {
      showFailure(`Max amount is ${maxDiscount(id)} for this discount`)
    } else {
      if (subOrder === 1) {
        splitOrder?.sub_order_1_discounts?.map((item) => {
          if (item.order_discount_line_id === id) {
            item.amount = value
          }
        })
        splitOrder?.sub_order_2_discounts?.map((item) => {
          if (item.order_discount_line_id === id) {
            item.amount = maxDiscount(id) - value
          }
        })
        setSplitOrderData({ ...splitOrder })
      } else {
        splitOrder?.sub_order_2_discounts?.map((item) => {
          if (item.order_discount_line_id === id) {
            item.amount = value
          }
        })
        splitOrder?.sub_order_1_discounts?.map((item) => {
          if (item.order_discount_line_id === id) {
            item.amount = maxDiscount(id) - value
          }
        })

        setSplitOrderData({ ...splitOrder })
      }
    }
  }
  return (
    <div>
      <SplitContainer>
        <Section>
          <SectionContent>
            <Orders>
              <ListContainer width="50%">
                <MainHeader>
                  <h3>Main Order</h3>
                </MainHeader>
                <LineItemList>
                  {mainOrder?.line_items?.map((item, index) => {
                    return (
                      <LineItems
                        key={index}
                        item={item}
                        index={index}
                        updateQuantity={(value, variation_id) => {
                          updateSelectedLineItems(variation_id, value, 1)
                        }}
                      />
                    )
                  })}

                  {mainOrder?.discount_lines?.map((item, index) => {
                    return (
                      <SplitDiscount
                        key={index}
                        item={item}
                        index={index}
                        updateQuantity={(value, variation_id) => {
                          updateSelectedLineItems(variation_id, value, 1)
                        }}
                      />
                    )
                  })}
                </LineItemList>
              </ListContainer>
              <ListContainer width="25%">
                <MainHeader>
                  <h3>Sub Order 1</h3>
                </MainHeader>{' '}
                <LineItemList>
                  {splitOrder?.sub_order_1_line_items?.map((item, index) => {
                    return (
                      <SubOrders
                        key={index}
                        item={item}
                        index={index}
                        updateQuantity={(value, variation_id) => {
                          updateSelectedLineItems(variation_id, value, 1)
                        }}
                      />
                    )
                  })}

                  {splitOrder?.sub_order_1_discounts?.map((item, index) => {
                    return (
                      <SubDiscount
                        key={index}
                        item={item}
                        index={index}
                        onUpdateMethod={(value, id) => {
                          updateDiscount(value, id, 1)
                        }}
                      />
                    )
                  })}
                </LineItemList>
              </ListContainer>
              <ListContainer width="25%">
                <MainHeader>
                  <h3>Sub Order 2</h3>
                </MainHeader>
                <LineItemList>
                  {splitOrder?.sub_order_2_line_items?.map((item, index) => {
                    return (
                      <SubOrders
                        key={index}
                        item={item}
                        index={index}
                        updateQuantity={(value, variation_id) => {
                          updateSelectedLineItems(variation_id, value, 2)
                        }}
                      />
                    )
                  })}

                  {splitOrder?.sub_order_2_discounts?.map((item, index) => {
                    return (
                      <SubDiscount
                        key={index}
                        item={item}
                        index={index}
                        onUpdateMethod={(value, id) => {
                          updateDiscount(value, id, 2)
                        }}
                      />
                    )
                  })}
                </LineItemList>
              </ListContainer>
            </Orders>
            <ButtonContainer>
              <DcButton
                size="sm"
                onClick={() => {
                  SplitOrder()
                }}
              >
                Split Order
              </DcButton>
            </ButtonContainer>
          </SectionContent>
        </Section>
      </SplitContainer>
    </div>
  )
}

const SplitContainer = styled.div`
  width: 100%;
  height: calc(100vh - 50px);
  background-color: #f2f7f8;
  padding: 10px;
  overflow: auto;
  padding-bottom: 10px;
`
const Orders = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 10px;
`
const ListContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  display: flex;
  flex-direction: column;
`

const LineItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  border-bottom: none;
  border-top: none;
`
const MainHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #e6e6e6;
  h3 {
    font-size: 16px;
    font-weight: 500;
  }
`

export default SplitOrder
